import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

export interface RegionState {
  culture: string;
  currency: string;
}

const initialState: RegionState = {
  culture: "",
  currency: "",
};

const regionSlice = createSlice({
  name: "region",
  initialState,
  reducers: {
    setRegion: (state, action: PayloadAction<RegionState>) => {
      state.culture = action.payload.culture;
      state.currency = action.payload.currency;
    },
    clearRegion: (state) => {
      state.culture = "";
      state.currency = "";
    },
  },
});

export const { setRegion, clearRegion } = regionSlice.actions;
export default regionSlice.reducer;
